const testimonials = [
  {
    name: "Jennifer H.",
    location: "Wesley Chapel, FL",
    rating: 5,
    text: "My son's hockey team qualified for a tournament in Toronto with three weeks' notice. We pulled his passport and discovered it had expired eight months earlier. Fast Passport Center processed his child passport renewal in five business days. He made the flight to Toronto, played in the tournament, and the team won their division. I honestly thought we would have to cancel the trip. Their team understood the urgency of youth sports travel in a way no other service did.",
    service: "Child Passport Renewal",
  },
  {
    name: "Marcus T.",
    location: "Wiregrass Ranch, FL",
    rating: 5,
    text: "I am a physician at AdventHealth Wesley Chapel and was invited to present at a medical conference in Frankfurt with two weeks' notice. My passport had expired during the pandemic and I had not renewed it. Fast Passport Center handled everything — document review, expedited submission, and tracking. I had my passport in hand four days before my flight out of TPA. Professional, fast, and they understood my schedule constraints.",
    service: "Emergency Passport Renewal",
  },
  {
    name: "Amanda R.",
    location: "Wesley Chapel, FL",
    rating: 5,
    text: "We booked a Disney cruise out of Tampa for spring break — our family of five, including three kids ages 6, 9, and 12. I checked our passports three weeks before sailing and found that all three kids' passports had expired. I panicked. Fast Passport Center walked me through the child passport process for each child, I shipped everything overnight from the UPS Store at The Shops at Wiregrass, and all three passports arrived five days later. We made the cruise with two days to spare.",
    service: "Child Passport",
  },
];

function Stars({ count }: { count: number }) {
  return (
    <div className="flex items-center gap-0.5">
      {Array.from({ length: count }).map((_, i) => (
        <i key={i} className="ri-star-fill text-[#F6C344] text-sm"></i>
      ))}
    </div>
  );
}

export default function WesleyChapelTestimonialsSection() {
  return (
    <section className="bg-[#F7F8FA] py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-14">
          <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">Reviews</p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-4">
            What Wesley Chapel Travelers Say
          </h2>
          <p className="text-gray-500 max-w-2xl mx-auto text-base leading-relaxed">
            Real reviews from Wesley Chapel families, Wiregrass Ranch residents, medical professionals, and youth sports parents who trusted Fast Passport Center with their expedited passports.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {testimonials.map((t, i) => (
            <div
              key={i}
              className="bg-white border border-gray-200 rounded-lg p-6 flex flex-col"
            >
              <Stars count={t.rating} />
              <p className="text-gray-600 text-sm leading-relaxed mt-4 flex-1 italic">
                &ldquo;{t.text}&rdquo;
              </p>
              <div className="mt-5 pt-4 border-t border-gray-200 flex items-center justify-between">
                <div>
                  <p className="font-bold text-[#1A365D] text-sm">{t.name}</p>
                  <p className="text-gray-400 text-xs">{t.location}</p>
                </div>
                <span className="text-xs font-semibold text-[#F6C344] bg-[#F6C344]/10 px-2.5 py-1 rounded-full whitespace-nowrap">
                  {t.service}
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}